// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2xKqf","footer":"ChangeClinic_footer__odkUj"};